// /*
//  * @Author: Hyman Choi
//  * @Date: 2021-01-11 08:35:55
//  * @LastEditTime: 2022-01-06 19:33:06
//  * @LastEditors: Please set LastEditors
//  * @Description: In User Settings Edit
//  * @FilePath: \Siui.Cloud.Medical.Web\src\utils\request.js
//  */
// import axios from "axios";
// import { MessageBox, Message } from "element-ui";
// import store from "@/store";
// import { getToken } from "@/utils/auth";
// // 取消重复请求
// import {
// 	addPendingRequest,
// 	removePendingRequest,
// } from "./encapsulationAxios/cancelRepeatRquest";
// // 请求重发
// import { againRequest } from "./encapsulationAxios/requestAgainSend";
// import {
// 	requestInterceptor as cacheReqInterceptor,
// 	responseInterceptor as cacheResInterceptor,
// } from "./encapsulationAxios/requestCache";

// // create an axios instance
// const service = axios.create({
// 	// baseURL: process.env.VUE_APP_BASE_API,
// 	// withCredentials: true, // send cookies when cross-domain requests
// 	timeout: 20000,
// });

// // request interceptor
// service.interceptors.request.use(
// 	(config) => {
// 		console.log("config", config);
// 		if (store.getters.token) {
// 			config.headers["token"] = getToken();
// 		}
// 		config.headers["operatorUserId"] = 1005703;
// 		config.headers["permissionList"] = "{'AllAllow'}";

// 		// 把当前请求信息添加到 pendingRequest 对象中
// 		addPendingRequest(config);
// 		// 请求缓存
// 		cacheReqInterceptor(config, service);

// 		return config;
// 	},
// 	(error) => {
// 		return Promise.reject(error);
// 	}
// );

// // response interceptor
// service.interceptors.response.use(
// 	(response) => {
// 		// 从 pending 列表中移除请求
// 		removePendingRequest(response);
// 		cacheResInterceptor(response);

// 		return response.data;
// 	},
// 	(error) => {
// 		// 从 pending 列表中移除请求
// 		removePendingRequest(error.config || {});

// 		// 需要特殊处理请求被取消的情况
// 		if (!axios.isCancel(error)) {
// 			// 请求重发
// 			return againRequest(error, service);
// 		}

// 		// 请求缓存处理方式
// 		if (
// 			axios.isCancel(error) &&
// 			error.message.data &&
// 			error.message.data.config.cache
// 		) {
// 			return Promise.resolve(error.message.data.data.data);
// 		}

// 		Message({
// 			message: error.message,
// 			type: "error",
// 			duration: 5 * 1000,
// 		});
// 		return Promise.reject(error);
// 	}
// );

// export default service;

import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { USER_KEY } from "@/assets/constant";
import storage from "good-storage";

// create an axios instance
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API,
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['token'] = getToken()
    }
    config.headers['operatorUserId'] = 1005703;
    config.headers['permissionList'] = "{'AllAllow'}";
    config.headers['terminalModel'] =navigator.userAgent;
    config.headers['mac'] ="";
    const userData=storage.get(USER_KEY);
    if(userData != null && userData.UserID!== null){
        config.headers['userId'] =userData.UserID;
    }
    //console.log('********** config **********', config);
    return config
  },
  error => {
    console.log('********** request error **********', error)
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    // console.log('********** response **********', response)
    return response.data

    // if (res.code !== 20000) {
    //   Message({
    //     message: res.message || 'Error',
    //     type: 'error',
    //     duration: 5 * 1000
    //   })

    // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    // to re-login
    //     MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
    //       confirmButtonText: 'Re-Login',
    //       cancelButtonText: 'Cancel',
    //       type: 'warning'
    //     }).then(() => {
    //       store.dispatch('user/resetToken').then(() => {
    //         location.reload()
    //       })
    //     })
    //   }
    //   return Promise.reject(new Error(res.message || 'Error'))
    // } else {
    //   return res
    // }
  },
  error => {
    console.log('********** response error **********', error)
    Message({
      message: error.response.data.message,
      type: 'error',
      duration: 10 * 1000
    })
    Promise.reject(error)
	return error.response.data
  }
)


export default service
